import React from 'react';

export default (
  <svg
    height="12"
    viewBox="0 0 18 12"
    width="18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fillRule="evenodd" transform="translate(-3 -6)">
      <path d="m0 0h24v24h-24z" />
      <path
        d="m11 18h2c.55 0 1-.45 1-1s-.45-1-1-1h-2c-.55 0-1 .45-1 1s.45 1 1 1zm-8-11c0 .55.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1h-16c-.55 0-1 .45-1 1zm4 6h10c.55 0 1-.45 1-1s-.45-1-1-1h-10c-.55 0-1 .45-1 1s.45 1 1 1z"
        fill="#adb5bd"
        fillRule="nonzero"
      />
    </g>
  </svg>
);
